import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { InputText } from "primereact/inputtext";
import { useParams } from "react-router-dom";
import { handleGetRequest } from "../../services/GetTemplate";
import { clientType, PackageTypes, status, importStatus, exportAirStatus, exportSeaStatus, deliveryStatus, statusArray } from "../../assets/data/data";
import { handlePutRequest } from "../../services/PutTemplate";
import { toast } from "react-toastify";
import Barcode from "react-barcode";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase/firebase";
import styles from "./packageDetail.module.scss";

const InfoItem = ({ label, value }) => (
    <div className={styles.infoItem}>
        <span className={styles.infoLabel}>{label}</span>
        <span className={styles.infoValue}>{value || "—"}</span>
    </div>
);

function PackageDetail({ data }) {
    const [brandData, setBrandData] = useState();
    const [clients, setClients] = useState([]);
    const [selectClients, setSelectedClients] = useState();
    const [couriers, setCouriers] = useState([]);
    const [selectedCouriers, setSelectedCouriers] = useState();
    const [selectedImportStatus, setSelectedImportStatus] = useState();
    const [selectedPackType, setSelectedPAckType] = useState();
    const [selectedExportSeaStatus, setSelectedExportSeaStatus] = useState();
    const [selectedDeliveryStatus, setSelectedDeliveryStatus] = useState();
    const [selectedExportAirStatus, setSelectedExportAirStatus] = useState();
    const [selectedUnit, setSelectedUnit] = useState();
    const [selectedShipment, setSlectedShipment] = useState();
    const [consigneeType, setConsigneeType] = useState();
    const [image, setImage] = useState();
    const [over, setOver] = useState();
    const { id } = useParams();
    const [role, setrole] = useState("");
    const [delivery, setDelivery] = useState();
    // Invoices uploaded before contentType was set on upload have no/incorrect
    // image MIME type in Firebase Storage, so the browser can't render them as
    // an <img>. Fall back to a plain link for those instead of a broken image.
    const [invoiceImgError, setInvoiceImgError] = useState(false);

    const getDetails = async () => {
        const res = await handleGetRequest(`/package/${data?.Waybill}`);
        const rese = await handleGetRequest("/userRole?role=client");
        const result = await handleGetRequest("/userRole?role=courier");
        setClients(rese?.data);
        setCouriers(result?.data);
        const keyData = res?.data;
        setBrandData(keyData);
        setSelectedClients(keyData?.name?._id);
        setSelectedImportStatus(keyData?.import_status);
        setSelectedExportSeaStatus(keyData?.export_sea_status);
        setSelectedDeliveryStatus(keyData?.delivery_status);
        setSelectedExportAirStatus(keyData?.export_air_status);
        setSelectedPAckType(keyData?.packageType);
        setSelectedUnit(keyData?.weight?.unit);
        setSlectedShipment(keyData?.shipmentMethod);
        setConsigneeType(keyData?.consigneeType);
        setSelectedCouriers(keyData?.courierName?._id);
        setDelivery(keyData?.deliveryInfo);
    };
    useEffect(() => {
        getDetails();
        setInvoiceImgError(false);
    }, [data?.Waybill]);

    console.log(brandData);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            Waybill: brandData?.Waybill ?? "",
            oversizePackage: "",
            name: "",
            consigneeName: brandData?.consigneeName ?? "",
            merchant: brandData?.merchant ?? "",
            description: brandData?.description ?? "",
            weight: brandData?.weight?.number ?? "",
            flightNumber: brandData?.flightNumber ?? "",
            status: "",
            courierName: "",
            shipmentMethod: "",
            packageType: "",
            unit: "",
            price: brandData?.price ?? "",
            shipmentNumber: brandData?.shipmentNumber ?? "",
            numberOfPieces: brandData?.numberOfPieces ?? "",
            consigneeType: brandData?.consigneeType ?? "",
            invoiceImage: "",
            import_status: "",
            export_sea_status: "",
            delivery_status: "",
            export_air_status: "",
            billTo: brandData?.billTo ?? "",
            trackingNumber: brandData?.trackingNumber ?? "",
            deliverInfo: brandData?.deliveryInfo ?? "",
            notes: brandData?.notes ?? "",
        },

        onSubmit: async (data) => {
            data.oversizePackage = over === "true" ? true : false;
            data.consigneeName = data?.consigneeName;
            data.number = data.weight;
            data.unit = selectedUnit;
            data.courierName = selectedCouriers;
            data.shipmentMethod = selectedShipment;
            data.packageType = selectedPackType;
            data.consigneeType = consigneeType;
            data.name = selectClients;
            data.deliverInfo = delivery;
            if (image) {
                data.invoiceImage = image;
            }
            const result = await handlePutRequest(data, "/editPackage");
            if (result?.success) {
                getDetails();
                toast.success("Package edited");
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    useEffect(() => {
        const role = localStorage.getItem("role");
        setrole(role);
    }, []);

    const uploadImage = async (file) => {
        let name = file.name;
        let filename = name.replace(/\.[^/.]+$/, "") + "-" + Math.floor(Math.random() * 10000000 + 1);
        const storageRef = ref(storage, filename);
        await uploadBytes(storageRef, file, { contentType: file.type }).then((snapshot) => {});
        await getDownloadURL(storageRef).then(async (url) => {
            setImage(url);
            const payload = {
                inventoryNumber: data?.Waybill,
                invoiceImage: url,
                invoiceuploaded: true,
            };
            const result = await handlePutRequest(payload, "/editPackage");
            if (result?.success) {
                getDetails();
                toast.success("Package edited");
            }
        });
    };

    const handleImportStatus = async (e) => {
        setSelectedImportStatus(e);

        const data = {
            status: e,
            id: data?.Waybill,
            name: brandData?.name?.firstName + " " + brandData?.name?.lastName,
            deliveryAddress: brandData?.name?.client?.deliveryAddress,
            email: brandData?.name?.email,
        };
        const res = await handlePutRequest(data, "/changeimportstatus");
        if (res?.success) {
            getDetails();
            toast.success("Package edited");
        }
    };

    const handleExportAirStatus = async (e) => {
        setSelectedImportStatus(e);
        const data = {
            status: e,
            id: data?.Waybill,
            name: brandData?.name?.firstName + " " + brandData?.name?.lastName,
            deliveryAddress: brandData?.name?.client?.deliveryAddress,
            email: brandData?.name?.email,
        };
        const res = await handlePutRequest(data, "/changeexportairstatus");
        if (res?.success) {
            getDetails();
            toast.success("Package edited");
        }
    };

    const handleExportSeaStatus = async (e) => {
        setSelectedImportStatus(e);
        const data = {
            status: e,
            id: data?.Waybill,
            name: brandData?.name?.firstName + " " + brandData?.name?.lastName,
            deliveryAddress: brandData?.name?.client?.deliveryAddress,
            email: brandData?.name?.email,
        };
        const res = await handlePutRequest(data, "/changeexportseastatus");
        if (res?.success) {
            getDetails();
            toast.success("Package edited");
        }
    };

    const handledeliveryStatus = async (e) => {
        setSelectedImportStatus(e);
        const data = {
            status: e,
            id: data?.Waybill,
            name: brandData?.name?.firstName + " " + brandData?.name?.lastName,
            deliveryAddress: brandData?.name?.client?.deliveryAddress,
            email: brandData?.name?.email,
        };
        const res = await handlePutRequest(data, "/packageStatusChange");
        if (res?.success) {
            getDetails();
            toast.success("Package edited");
        }
    };
    return (
        <>
            {role === "client" && (
                <div className={styles.uploadCard}>
                    <label htmlFor="invoiceImage" className={classNames({ "p-error": isFormFieldValid("invoiceImage") }, "Label__Text")}>
                        Upload invoice Image
                    </label>
                    <InputText id="invoiceImage" type="file" name="invoiceImage" onChange={(e) => uploadImage(e.target.files[0])} className={classNames({ "p-invalid": isFormFieldValid("invoiceImage") }, "Input__Round")} />
                    {getFormErrorMessage("invoiceImage")}
                    {image && (
                        <div className={styles.imagesRow}>
                            <div className={styles.imageTile}>
                                <img src={image} alt="Invoice" />
                            </div>
                        </div>
                    )}
                </div>
            )}

            <div className={styles.contentCard}>
                <div className={styles.infoGrid}>
                    <InfoItem label="Way Bill" value={formik.values.Waybill} />
                    <InfoItem label="Description" value={formik.values.description} />
                    <InfoItem label="Bill To" value={brandData?.name?.firstName ? `${brandData?.name?.firstName} ${brandData?.name?.lastName}` : ""} />
                    <InfoItem label="Merchant Name" value={formik.values.merchant} />
                    <InfoItem label="Package Name" value={formik.values.billTo} />
                    <InfoItem label="Tracking Number" value={formik.values.trackingNumber} />
                    <InfoItem label="Shipment Method" value={selectedShipment} />
                    <InfoItem label="Oversized Package?" value={over === true || over === "true" ? "Yes" : "No"} />
                    <InfoItem label="Delivery Information" value={delivery} />
                    <InfoItem label="Weight of Package" value={formik.values.weight ? `${formik.values.weight} ${selectedUnit || ""}` : ""} />
                    <InfoItem label="Consignee Name" value={formik.values.consigneeName} />
                    <InfoItem label="Package Status" value={selectedDeliveryStatus} />
                    <InfoItem label="Courier Name" value={brandData?.courierName?.courier?.businessName} />
                    <InfoItem label="Package Type" value={selectedPackType} />
                    <InfoItem label="Number of Pieces" value={formik.values.numberOfPieces} />
                    <InfoItem label="Price" value={formik.values.price} />
                    <InfoItem label={selectedShipment === "shipment" ? "Shipment Number" : "Flight Number"} value={selectedShipment === "shipment" ? formik.values.shipmentNumber : formik.values.flightNumber} />
                </div>

                {formik.values.notes && (
                    <div className={styles.fieldGroup}>
                        <label>Notes</label>
                        <div className={styles.infoValue}>{formik.values.notes}</div>
                    </div>
                )}

                {formik.values.Waybill && (
                    <div className={styles.barcodeBox}>
                        <Barcode value={formik.values.Waybill} height={50} />
                    </div>
                )}

                {brandData?.notesImages?.length > 0 && (
                    <div className={styles.fieldGroup}>
                        <label>Notes Images</label>
                        <div className={styles.imagesRow}>
                            {brandData?.notesImages?.map((image, index) => (
                                <div className={styles.imageTile} key={index}>
                                    <img src={image} alt="Note" />
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {brandData?.invoiceImage && (
                    <div className={styles.fieldGroup}>
                        <label>Invoice Image</label>
                        {invoiceImgError ? (
                            <a href={brandData.invoiceImage} target="_blank" rel="noopener noreferrer" className={styles.invoiceFallbackLink}>
                                <i className="pi pi-file" /> Open uploaded invoice
                            </a>
                        ) : (
                            <div className={styles.imagesRow}>
                                <div className={styles.imageTile} style={{ width: "320px" }}>
                                    <img src={brandData.invoiceImage} alt="Invoice" style={{ height: "auto", objectFit: "contain" }} onError={() => setInvoiceImgError(true)} />
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
}

export default PackageDetail;
